import React from 'react'
import { css } from '@emotion/core'
import { HeaderBlock, Body1, colors, BillboardButton, LayoutBand } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import sendAnalytics from '../../services/analytics-helper'
import { getExternalBaseUrl } from '../../services/url-service'

const homePageFooterCss = css`
  background: ${colors.gray03};
  padding-top: 32px;
  padding-bottom: 32px;
`

export default function HomePageFooter(): JSX.Element {
  const [t] = useTranslation()

  return (
    <LayoutBand maxWidth="sm" css={homePageFooterCss}>
      <HeaderBlock size="sm" heading={t('ancestors.about-family-search.header')} />
      <Body1>{t('ancestors.about-family-search.description')}</Body1>
      <BillboardButton
        to={`${getExternalBaseUrl()}/register`}
        external
        onClick={() => {
          sendAnalytics({ link_page: 'Home', link_name: 'Footer: Free Account' })
        }}
        data-testid="home-footer-free-account"
      >
        {t('ancestors.free-acount.link')}
      </BillboardButton>
    </LayoutBand>
  )
}
